import { Injectable } from '@angular/core';
import { UrlFactory } from './url-factory';

@Injectable({ providedIn: 'root' })
export class JwtFrontendGateway {
  constructor(private _urlFactory: UrlFactory) {}

  profileCacheUrl(sub: string) {
    return this._urlFactory.createUrl('jwtFrontend', '', { sub });
  }
}
